import { render, staticRenderFns } from "./decDocXiangHuiContent.vue?vue&type=template&id=3509098f"
import script from "./decDocXiangHuiContent.vue?vue&type=script&lang=js"
export * from "./decDocXiangHuiContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports